module.exports = __webpack_public_path__ + "static/Energy-Saving-Solar-Home-Lighting-System-91bfa936384f6e2db02cbe2e24bd535b.jpg";